enum AddToBagModalEnum {
	unavailableProductCard = 'unavailableProductCard'
	// testtest = 'testtest'
}

export default AddToBagModalEnum;
